<form [formGroup]="form">
  <div
    class="qa-variable-row"
    *ngFor="let externVarName of getExternVariableNames(false)"
    [ngClass]="{'dirty-entry': form.get(externVarName).dirty}"
  >
    <div class="qa-extern-field qa-extern-name">
      <label class="qa-field-label" [attr.for]="externVarName">Name</label>
      <input
        [value]="externVarName"
        id="{{externVarName}}"
        name="{{externVarName}}"
        [formControlName]='externVarName'
        [class.is-invalid]="!!nameError(externVarName)"
        (keydown)="onKeyDown($event, externInputEl, externVarName)"
        class="form-control"
        spellcheck="false"
        autocomplete="off"
        #externInputEl
      >
    </div>

    <div class="qa-extern-field">
      <label class="qa-field-label">{{_(KEYS.EDITOR.QUESTIONNAIRE_TYPE)}}</label>
      <select class="form-control qa-custom-select" [formControlName]='externVarName + "Format"' (change)="onResetDefault(externVarName)">
        <option value="text">{{_(KEYS.EDITOR.TYPE_STRING)}}</option>
        <option value="numeric">{{_(KEYS.EDITOR.TYPE_NUMERIC)}}</option>
        <option value="date">{{_(KEYS.EDITOR.TYPE_DATE)}}</option>
      </select>
    </div>

    <div class="qa-extern-field">
      <label class="qa-field-label">Default</label>
      <input
        [type]="getInputType(externVarName)"
        [formControlName]='externVarName + "Default"'
        [class.is-invalid]="!!defaultError(externVarName)"
        (keydown)="onKeyDown($event, externInputEl, externVarName)"
        class="form-control default-value"
      >
    </div>

    <div class="qa-extern-actions">
      <button
        type="button"
        class="qa-icon-btn qa-icon-btn-save"
        [attr.aria-label]="_(KEYS.EDITOR.SAVE_VARIABLE)"
        [disabled]="(form.get(externVarName).errors || form.get(externVarName + 'Default').errors || !form.dirty)  ? true : null"
        (click)="onEdit(externInputEl.value, externVarName)"
      >
        <i class="fa fa-check" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="qa-icon-btn"
        [attr.aria-label]="_(KEYS.EDITOR.RESET_VARIABLE)" [attr.title]="_(KEYS.EDITOR.RESET_VARIABLE)"
        (click)="onUndo(externVarName)"
      >
        <i class="fa fa-undo" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="qa-icon-btn qa-icon-btn-danger"
        [attr.aria-label]="_(KEYS.EDITOR.DELETE_VARIABLE)" [attr.title]="_(KEYS.EDITOR.DELETE_VARIABLE)"
        (click)="onRemove(externVarName)"
      >
        <i class="fa fa-trash" aria-hidden="true"></i>
      </button>
    </div>
    <p class="qa-variable-msg qa-variable-msg-error" *ngIf="nameError(externVarName) || defaultError(externVarName) as error" role="alert">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{error}}
    </p>
  </div>
</form>

<button type="button" class="qa-add-variable" (click)="onAdd()">
  <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.EDITOR.ADD_EXTERN_VARIABLE)}}
</button>
